import { ref } from "vue";

import * as tmi from "@/constants";

import type { ProductConfig } from "@/types/products/product-config";

import {
    osLessonsKey,
    osProductKey,
    osVimeoKey,
    positionSizeCalculatorKey,
    webinarKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers"

const initialView: string = osLessonsKey;
const selectedView = ref< string >( initialView );
const productConfig: ProductConfig = {
    slug: osProductKey
}

const productActionTopicKeys = [
    osVimeoKey,
    // bonusReportKey,
    osLessonsKey,
    webinarKey,
    positionSizeCalculatorKey,
    tmi.SpreadCalculatorKey
];

export function useOptionsSoup() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( osProductKey, productActionTopicKeys );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView
    }
}
